<template>
  <div class="container diy-page">
    <v-head></v-head>
    <v-left current="email"></v-left>
    <div style="background:rgb(251,251,251)">
      <div style="position:relative;">
        <div style="min-height:555px;background:white;">
          <div style="margin-bottom: 5px;">
            <el-button size="small" class="pointer" @click="to_edit(null)"><i class="el-icon-plus"></i>Add</el-button>
          </div>
          <el-table
            :data="list_data.list"
            v-loading="loading"
            border
            style="width: 100%"
          >
            <el-table-column prop="name" label="Template Name" min-width="222">
              <template slot-scope="scope">
                <a>{{ scope.row.name }}</a>
                <p style="color: gray;">Subject: {{ scope.row.subject }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="sort" width="133">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.sort"
                  style="width: 80px"
                  @blur="changeSort(scope.row)"
                ></el-input>
              </template>   
            </el-table-column>
            <el-table-column prop="status" label="status" width="133">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.status_bool" active-color="#13ce66" inactive-color="#aaaaaa" @change="changeStatus(scope.row)"></el-switch>
              </template>   
            </el-table-column>
            <el-table-column prop="handle" label="Handle" width="133">
              <template slot-scope="scope">
                <el-tag type="warning" size="small" class="pointer" @click="remove(scope.row.id)">删除</el-tag>
                <el-tag size="small" class="pointer" @click="to_edit(scope.row)">编辑</el-tag>
              </template>   
            </el-table-column>
          </el-table>
        </div>
      </div>
      <component :is="popName2" :row="editItem"></component>
    </div>
  </div>
</template>
<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
import email_left from "@/pages/email/_left";
import pop_edit_templates from "@/pages/email/_pop_edit_templates";

export default {
  components: {
    "v-head": head,
    "v-left": left,
    'email-left': email_left,
    pop_edit_templates,
  },
  data() {
    return {
      uid: 0,
      loading:false,
      popName2: "",
      editItem:null,
      filter: {
        size: 20,
        page:1,
      },
      list_data: {
        list: [],
        size: 20,
        page: 1,
        total:100,
      },

    };
  },
  methods: {
    handleClick(e) {
    },
    to_edit(row) { 
      this.editItem = row
      this.popName2 = 'pop_edit_templates'
    },
    changeSort(item) {
      this.$http
        .post("/v1/pri/store-email-templates/change-sort", { id: item.id, sort: item.sort })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    changeStatus(item){
      this.$http.post('/v1/pri/store-email-templates/change-status', {id:item.id, status:item.status_bool ? 1 : 2})
      .then( (response) => {
          var res = response.data;
          if (res.code == 1) {
              this.$message({
                  message: '操作成功',
                  type: 'success'
              });
          } else {
              this.$message({
                  message: res.msg,
                  type: 'warning'
              });
          }
      })             
    },
    remove(id){
      this.$confirm('删除模板?', 'notice', {
          confirmButtonText: 'Send',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.$http
            .post("/v1/pri/store-email-templates/remove", {id:id})
            .then((response) => {
              var res = response.data;
              if (res.code == 1) {
                this.$message({
                  message: "Remove success",
                  type: "success",
                });
                this.getList();
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning",
                });
              }
            })
        }) 
    },
    get_messages_from_left(e) { 
      this.filter.mailbox_email = e.mailbox_email
      this.filter.label_id = e.label_id
      this.filter.page = 1;
      this.get_messages();
    },
    getList() {
      this.loading = true;
      this.$http
        .post("/v1/pri/store-email-templates/list", this.filter)
        .then((response) => {
          this.loading = false;
          var res = response.data;
          if (res.code == 1) {
            this.list_data = res.data
          }
        }).catch(() => { 
          this.loading = false;
        })
    },
  },
  mounted() {
    // this.$store.commit('set_current_menu', {name:'email'});

    var admin_password = this.getCookie("admin_password");
    if (admin_password === 'b1315E8') {
      this.uid = parseInt(localStorage.getItem("uid"));
    }
    if (this.uid != 1 && this.uid != 10000 && this.uid != 10001) { 
      return;
    }
    this.getList();
  }
};
</script>
<style>

.unread-row-style{font-size: 16px;font-weight: bold;color: black;}
</style>



// WEBPACK FOOTER //
// src/pages/email/Templates.vue